<div class="m-2" *ngIf="quest.showFilter">
    <input type="text" class="form-control" [(ngModel)]="quest.filterText" placeholder="Filter" (keyup)="loadFilteredOptions()" (change)="loadFilteredOptions()" />
</div>

<ng-container *ngIf="quest.groupBy">
    <div class="tooltip-grouped" *ngFor="let obj of normalOptions">
        <div class="tooltip-title">{{obj.Label}}</div>
        <div class="input-buttons">
            <ng-container *ngFor="let item of obj.Options">
                <button type="button" class="input-button" [class.selected]="activeSelectedOption(quest, item)" (click)="selectOption(quest, item)" placement="top" [ngbTooltip]="item.Tooltip" [disableTooltip]="!item.Tooltip || quest.groupBy=='Tooltip'">
                    <span>
                        {{item.Label}}
                        <ng-container *ngIf="item.Code"> {{item.Code}}</ng-container>
                    </span>
                </button>
            </ng-container>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!quest.groupBy">
    <div class="input-buttons">
        <ng-container *ngFor="let item of normalOptions">
            <button type="button" class="input-button" [class.selected]="activeSelectedOption(quest, item)" (click)="selectOption(quest, item)" placement="top" [ngbTooltip]="item.Tooltip" [disableTooltip]="!item.Tooltip">
                <span>
                    {{item.Label}}
                    <ng-container *ngIf="item.Code"> {{item.Code}}</ng-container>
                </span>
            </button>
        </ng-container>
        <ng-container *ngIf="quest.hasDynamicOptions">
            <ng-container *ngFor="let item of dynamicOptions">
                <button type="button" class="input-button" [class.selected]="activeSelectedOption(quest, item)" (click)="selectOption(quest, item)">
                    <span>
                        {{item.Label}}
                        <ng-container *ngIf="item.Code"> {{item.Code}}</ng-container>
                    </span>
                </button>
            </ng-container>
        </ng-container>
    </div>
</ng-container>
